import {ChatCompletionCreateParamsNonStreaming} from 'openai/resources';
import apiV2Service from '../api/api-v2.service';
import {ChatCompletionWithFunctionToolsOnly} from '../shared/copilot/openAI/openAI.types';

const BASE_URL = 'AI';

async function createChatCompletion(
  {
    model,
    messages,
    tools,
    temperature,
    response_format,
    tool_choice,
    reasoning_effort,
    verbosity,
  }: ChatCompletionCreateParamsNonStreaming,
  abortSignal?: AbortSignal,
) {
  const response = await apiV2Service.executePostRequest<ChatCompletionWithFunctionToolsOnly>(
    `${BASE_URL}/ChatCompletions`,
    {},
    {
      model,
      messages,
      tools,
      temperature,
      response_format,
      tool_choice,
      reasoning_effort,
      verbosity,
    },
    {abortSignal},
  );

  return response.data;
}

const openAiApi = {
  createChatCompletion,
};

export default openAiApi;
